// @ts-nocheck
import { apiBaseUrl } from '../api/client';
import { getCurrentUser, refreshSession } from '../auth/session';
import { showToast } from '../components/toast/toast';
import { t } from '../i18n';
import { translateApiMessage } from '../i18n/api-errors';
import { refreshPostsAccess } from './posts-access';

const RELATIONSHIPS = ['father', 'mother', 'partner', 'sibling', 'friend', 'other'];

async function apiFetch(path, options = {}) {
  const headers = { ...(options.headers || {}) };
  if (options.body && !headers['Content-Type'] && !headers['content-type']) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(`${apiBaseUrl}${path}`, {
    credentials: 'include',
    ...options,
    headers,
  });
  const body = res.status === 204 ? null : await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body?.message || 'Request failed');
    err.status = res.status;
    err.code = body?.code;
    throw err;
  }
  return body;
}

function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text ?? '';
  return div.innerHTML;
}

function relationshipLabel(key) {
  const map = {
    father: t('pethernity.relFather'),
    mother: t('pethernity.relMother'),
    partner: t('pethernity.relPartner'),
    sibling: t('pethernity.relSibling'),
    friend: t('pethernity.relFriend'),
    other: t('pethernity.relOther'),
  };
  return map[key] || key;
}

export async function loadHeadstoneMembers(headstoneId) {
  return apiFetch(`/headstones/${headstoneId}/members`);
}

export async function inviteHeadstoneMember(headstoneId, email, relationship) {
  return apiFetch(`/headstones/${headstoneId}/members`, {
    method: 'POST',
    body: JSON.stringify({ email, relationship }),
  });
}

export async function revokeHeadstoneMember(headstoneId, memberId) {
  return apiFetch(`/headstones/${headstoneId}/members/${memberId}`, {
    method: 'DELETE',
  });
}

export async function acceptHeadstoneInvite(token) {
  return apiFetch(`/headstone-invites/${encodeURIComponent(token)}/accept`, {
    method: 'POST',
  });
}

export function renderFamilySection(opts) {
  const { members = [], isOwner } = opts;
  const options = RELATIONSHIPS.map(
    (key) => `<option value="${key}">${escapeHtml(relationshipLabel(key))}</option>`,
  ).join('');

  const rows = members.length
    ? members
        .map((m) => {
          const revoke =
            isOwner && m.status !== 'revoked'
              ? `<button type="button" class="view-family-revoke" data-member-id="${escapeHtml(m.id)}">${t('pethernity.familyRevoke')}</button>`
              : '';
          const status =
            m.status === 'accepted' ? t('pethernity.familyAccepted') : t('pethernity.familyPending');
          return `
            <li class="view-family-row">
              <span>${escapeHtml(m.inviteeEmail)}</span>
              <span>${escapeHtml(relationshipLabel(m.relationship))}</span>
              <span>${escapeHtml(status)}</span>
              ${revoke}
            </li>
          `;
        })
        .join('')
    : `<li class="view-family-empty">${t('pethernity.familyEmpty')}</li>`;

  const form = isOwner
    ? `
      <form id="view-family-form" class="view-family-form">
        <label class="view-guest-label" for="view-family-email">${t('pethernity.familyEmail')}</label>
        <input type="email" id="view-family-email" required maxlength="120" placeholder="name@email.com">
        <label class="view-guest-label" for="view-family-relationship">${t('pethernity.familyRelationship')}</label>
        <select id="view-family-relationship">${options}</select>
        <button type="submit" class="modal-btn view-guest-submit">${t('pethernity.familySend')}</button>
      </form>
    `
    : '';

  return `
    <section id="view-family-section" class="view-family-section">
      <h4 class="view-tributes-title">${t('pethernity.familyTitle')}</h4>
      <ul class="view-family-list">${rows}</ul>
      ${form}
    </section>
  `;
}

export function bindFamilySection(headstoneId, isOwner, onChanged) {
  const form = document.getElementById('view-family-form');
  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const email = document.getElementById('view-family-email')?.value.trim();
    const relationship = document.getElementById('view-family-relationship')?.value;
    if (!email) return;
    try {
      await inviteHeadstoneMember(headstoneId, email, relationship);
      showToast(t('pethernity.familySent'));
      onChanged?.();
    } catch (err) {
      showToast(translateApiMessage(err.message) || t('pethernity.familyFailed'));
    }
  });

  document.querySelectorAll('.view-family-revoke').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const memberId = btn.getAttribute('data-member-id');
      if (!memberId) return;
      try {
        await revokeHeadstoneMember(headstoneId, memberId);
        showToast(t('pethernity.familyRevoked'));
        onChanged?.();
      } catch (err) {
        showToast(translateApiMessage(err.message) || t('pethernity.familyFailed'));
      }
    });
  });
}

export async function tryAcceptHeadstoneInvite(token) {
  const user = getCurrentUser() || (await refreshSession());
  if (!user) return { ok: false, needAuth: true };
  try {
    const result = await acceptHeadstoneInvite(token);
    await refreshPostsAccess();
    showToast(t('pethernity.familyInviteAccepted'));
    return { ok: true, result };
  } catch (err) {
    showToast(translateApiMessage(err.message) || t('pethernity.familyInviteFailed'));
    return { ok: false, error: err };
  }
}
